import { FormatUrlParams, 
         FormatBookingFields,
         InitializeFields,
         ReformatAPIPayload,
         FormatQueryParams,
         ReplaceParameterValues,
         FormatApptPayload,
         FormatCustomerNotificationType,
         FormatCustomerAppointmentPayload,
         UpdateOnSchedAvailabilityCalendarColorScheme }     from "./formatUtils";
import { CustomEvents, CalendarCustomEvents, GetEventType } from "./customEvents";
import { Loading }                                          from "./loading";
import { GetRandomColour }                                  from "./styleUtils";
import { Forms }                                            from "./forms";
import { BuildFormRows, ValidateForm }                      from "./formUtils";
import { JumpToFirstAvailable, 
         AvailableTimes, 
         Durations,
         GetTimezone,
         IsMonthView,
         CustomDays,
         CustomMonths,
         CalendarDayDisabler,
         GetMultiResourceData,
         ClickAvailabilityWindow,
         OnAvailableDaySelect,
         OnAvailableMonthChange,
         HandleInitialAvailabilityLoad,
         FirstAvailableInWeek,
         MatchResourceTimes, }                              from "./availabilityUtils";
import { Internationalize }                                 from './languages'
import { CheckElements, IsEmpty }                           from './identifierUtils'
import { CheckErrors }                                      from './errorUtils'
import { Toast, successToastMsgs }                          from './toasts'
import { SetState }                                         from './stateUtils'
import { CalendarViews, CalendarReasonCodes }               from './calendarUtils'


export const OnSchedUtils = {
  FormatUrlParams,
  FormatBookingFields,
  CustomEvents,
  Loading,
  GetRandomColour,
  Forms,
  UpdateOnSchedAvailabilityCalendarColorScheme,
  JumpToFirstAvailable,
  ReformatAPIPayload,
  BuildFormRows,
  AvailableTimes,
  ValidateForm,
  Internationalize,
  CheckElements,
  CheckErrors,
  Durations,
  Toast,
  successToastMsgs,
  FormatQueryParams,
  GetTimezone,
  InitializeFields,
  SetState,
  CalendarViews,
  IsEmpty,
  CalendarCustomEvents,
  CalendarReasonCodes,
  GetEventType,
  GetMultiResourceData,
  ReplaceParameterValues,
  MatchResourceTimes,
  FormatApptPayload,
  FormatCustomerNotificationType,
  FormatCustomerAppointmentPayload,
  ClickAvailabilityWindow,
  IsMonthView,
  CustomDays,
  CustomMonths,
  CalendarDayDisabler,
  OnAvailableDaySelect,
  OnAvailableMonthChange,
  HandleInitialAvailabilityLoad,
  FirstAvailableInWeek,
}
